// extracted by mini-css-extract-plugin
export default {"inlineInputButton":"style_inlineInputButton__jT9rw"};